import { createFeatureSelector } from "@ngrx/store";

import { BusinessClassificationState } from "../models/business-classification-state";
import { StoreKeys } from "../store-keys";

export class BusinessClassificationSelectors {
	static readonly businessClassifications = createFeatureSelector<BusinessClassificationState>(
		StoreKeys.businessClassificationStateKey
	);
}
